import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';

import styles from './ChangePlanStatusModal.module.scss';

interface IChangePlanStatusErrorModalProps {
  visible: boolean;
  text: string | undefined;
  afterClose: (() => void) | undefined;
  onClose: () => void;
}

export const ChangePlanStatusErrorModal = ({
  visible,
  text,
  onClose,
  afterClose,
}: IChangePlanStatusErrorModalProps) => {
  return (
    <Modal modalBodyClassName={styles.ModalBody} visible={visible} onClose={onClose} afterClose={afterClose}>
      <ModalHeader sizeText="small" size="large" title="Ошибка смены статуса плана" />
      <ModalBody size="content" border="bottom">
        <h2 className="shared-title__with-margin shared-title__bold">Уважаемый пользователь!</h2>
        {text}
      </ModalBody>
      <ModalActions placement="left">
        <Button text="Закрыть" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};
